import React from 'react'

import MapIcon from "../../../assets/icons/MapPoint.svg"
import ClockIcon from "../../../assets/icons/Clock.svg"

import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import 'swiper/css';

function CardProject({ travel, handleDelete }) {

    let { name, palace, timeTravel, images, _id, discount, price } = travel
  
    return (
        <div className='card'>
            {
                price && <div className='price'>
                    <p className='price-p' >
                        {price}</p> /  <p className='discount'>  {discount} </p>
                </div>
            }

            <Swiper
                spaceBetween={5}
                slidesPerView={1}
                breakpoints={{
                    50: {
                        slidesPerView: 1,
                    },
                    576: {
                        slidesPerView: 1,
                    },
                    1000: {
                        slidesPerView: 1,
                    },
                    1500: {
                        slidesPerView: 1,
                    },
                }}
            >
                {
                    images.map((item) => {
                        return (
                            <SwiperSlide key={item._id}>
                                
                                <div className="card-projects"  >
                                    {/* <img alt='img-project' src={`${BASE_URL}/uploads/travel/${item}`} /> */}
                                    <img alt='img-project' src={item} />
                                </div>
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
            <div className='div-card-tittle-place' >
                <h1>
                    <Link to={`/project-page/${_id}`} >
                        {name}
                    </Link>
                </h1>
                <div className='place-project-card flex-div-5'>
                    <img alt='map-icon' src={MapIcon} className='icon' />
                    <p>{palace}</p>
                </div>
            </div>
            {
                timeTravel && <div className='details-card' >
                    <div className='icon-details' >
                        <img alt='map-icon' src={ClockIcon} className='icon' />
                        <p>{timeTravel}</p>
                    </div>
                </div>
            }
            <div className='update-delete-buttons'>
                <Link to={`/admin/update-projects/${_id}`} className='update' >تعديل </Link>
                <button className='delete' onClick={() => handleDelete(_id)} >حذف</button>
            </div>
        </div>
    )
}

export default CardProject